<template>
  <div>
    <!-- TODO: refactor markup using the data in 'menu'Secondary Menu Component -->
    <!-- {{ menu }} -->
    <ul class="secondary-menu">
      <li v-for="(route, index) in menu" :key="index">
        <router-link :to="{name:route.routeName}" class="nav-link">
          <b-icon :icon="route.icon" class="mr-2"></b-icon>
          <small>{{route.label}}</small>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { secondary } from '../nav'

export default {
  data () {
    return {
      menu: secondary
    }
  }
}
</script>
